import { Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CgMenu as MenuIcon } from "react-icons/cg";
import { MdOutlineArrowBack as BackIcon } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import ContractClose from "../../assets/icons/approve file.svg";
import Buyers from "../../assets/icons/buyers.svg";
import Companies from "../../assets/icons/companies.svg";
import Contacts from "../../assets/icons/contacts.svg";
import Document from "../../assets/icons/document.svg";
import Exclusives from "../../assets/icons/exclusives.svg";
import Home from "../../assets/icons/home-outline.svg";
import Leads from "../../assets/icons/leads.svg";
import Offers from "../../assets/icons/offers.svg";
import pipeline from "../../assets/icons/pipeline.svg";
import Properties from "../../assets/icons/properties.svg";
import Proposals from "../../assets/icons/proposals.svg";
import Smart from "../../assets/icons/smart-plans.svg";
import Tasks from "../../assets/icons/tasks.svg";
import Logo from "../../assets/images/Logo.png";
import Logo2 from "../../assets/images/Logo2.png";
import LeftArrow from "../../assets/svgs/left-arrow.svg";
import RightArrow from "../../assets/svgs/right-arrow.svg";
import {
  setIsShowSettingSidebar,
  setIsSidebarCollapsed,
} from "../../redux/Action/AuthActions";
import "./Sidebar.css";

/* -------------------- NO UI CHANGE -------------------- */

const sidebarOptions = [
  { name: "Home", icon: Home, link: "/" },
  { name: "Contacts", icon: Contacts, link: "/contacts" },
  { name: "Companies", icon: Companies, link: "/companies" },
  { name: "Properties", icon: Properties, link: "/properties" },
  { name: "Buyers", icon: Buyers, link: "/buyers", hasBottomBorder: true, specialClass: true },
  { name: "Tasks", icon: Tasks, link: "/tasks" },
  { name: "Pipeline", icon: pipeline, link: "/pipeline" },
  { name: "Scorecard", icon: pipeline, link: "/scorecard" },
  { name: "Contract to Close", icon: ContractClose, link: "/contact-close" },
  { name: "TouchPlans", icon: Smart, link: "/touch-plans", hasBottomBorder: true, specialClass: true },
  { name: "Leads", icon: Leads, link: "/leads" },
  { name: "BOV", icon: Proposals, link: "/proposals" },
  { name: "Exclusives", icon: Exclusives, link: "/exclusives" },
  { name: "Offers", icon: Offers, link: "/offers" },
  { name: "Executed LOI", icon: Document, link: "/executedloi" },
  { name: "Under Contract", icon: Document, link: "/under-contract" },
  { name: "Closed", icon: Document, link: "/closed" },
];

const settingOptions = [
  {
    title: "Archives",
    type: "dropdown",
    items: [
      { name: "Contact Archive", link: "/settings/contact-archive" },
      { name: "Company Archive", link: "/settings/company-archive" },
      { name: "Property Archive", link: "/settings/property-archive" },
      { name: "Buyer Archive", link: "/settings/buyer-archive" },
      { name: "Exclusives Archive", link: "/settings/exclusive-archive" },
      { name: "Executed LOI Archive", link: "/settings/executedloi-archive" },
      { name: "Under Contract Archive", link: "/settings/undercontract-archive" },
      { name: "Contract To Close Archive", link: "/settings/Contract-to-closed-archive" },
      { name: "Closed Archive", link: "/settings/closed-archive" },
    ],
  },
  {
    title: "Tags",
    type: "dropdown",
    items: [
      { name: "Contact Tags", link: "/settings/contact-tags" },
      { name: "Company Tags", link: "/settings/company-tags" },
      { name: "Property Tags", link: "/settings/property-tags" },
    ],
  },
  {
    type: "normal",
    items: [
      { name: "Users", link: "/settings/users" },
      { name: "Property Types", link: "/settings/property-types" },
      { name: "Lead Sources", link: "/settings/lead-sources" },
      { name: "Tenant", link: "/settings/tenant" },
      { name: "Designated Agents", link: "/settings/designated-agents" },
      { name: "ScoreCard History", link: "/settings/ScoreCardHistory" },
      { name: "Connected App", link: "/settings/connected-app" },
      { name: "My Profile", link: "/settings/profile" },
      { name: "Logs", link: "/settings/Logs" },
    ],
  },
];

/* 🔑 ONLY ADDITION */
const dropdownRouteMap = {
  Archives: [
    "/settings/contact-archive",
    "/settings/company-archive",
    "/settings/property-archive",
    "/settings/buyer-archive",
    "/settings/exclusive-archive",
    "/settings/executedloi-archive",
    "/settings/undercontract-archive",
    "/settings/Contract-to-closed-archive",
    "/settings/closed-archive",
  ],
  Tags: [
    "/settings/contact-tags",
    "/settings/company-tags",
    "/settings/property-tags",
  ],
};

const SidebarComponent = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userType = useSelector((state) => state.userType);
  const isSidebarCollapsed = useSelector((state) => state.isSidebarCollapsed);
  const isShowSettingSidebar = useSelector((state) => state.isShowSettingSidebar);

  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [openSetting, setOpenSetting] = useState(null);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const toggleSetting = (title) => {
    setOpenSetting(openSetting === title ? null : title);
  };

  useEffect(() => {
    if (location.pathname.includes("settings")) {
      if (userType === 3) {
        dispatch(setIsShowSettingSidebar(false));
      } else {
        dispatch(setIsShowSettingSidebar(true));
      }
    } else {
      dispatch(setIsSidebarCollapsed(false));
      dispatch(setIsShowSettingSidebar(false));
    }
  }, [location.pathname, userType, dispatch]);

  /* ✅ FIX: keep dropdown open after selection */
  useEffect(() => {
    const currentPath = location.pathname;

    Object.entries(dropdownRouteMap).forEach(([title, routes]) => {
      if (routes.some(route => currentPath.startsWith(route))) {
        setOpenSetting(title);
      }
    });
  }, [location.pathname]);

  const sidebarList =
    userType === 3
      ? sidebarOptions.filter((el) => el.name !== "Users")
      : sidebarOptions;

  return (
    <>
      <button className="toggle-button" onClick={toggleSidebar}>
        {isSidebarVisible ? <BackIcon /> : <MenuIcon size={20} />}
      </button>

      <div className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""} ${isSidebarVisible ? "visible" : ""}`}>
        <div className={`${isSidebarCollapsed ? "top-section-collapsed" : "top-section"}`}>
          <div>
            <NavLink to="/">
              <img src={isSidebarCollapsed ? Logo2 : Logo} alt="Logo" />
            </NavLink>
          </div>

          {isShowSettingSidebar ? null : (
            <button
              onClick={() => {
                dispatch(setIsSidebarCollapsed(!isSidebarCollapsed));
              }}
            >
              <img src={isSidebarCollapsed ? RightArrow : LeftArrow} alt="Collapse Icon" className="arrow-icon" />
            </button>
          )}
        </div>

        {isShowSettingSidebar ? (
          <ul className={`flex gap-1 ${isSidebarCollapsed ? "options-collapsed" : "options"}`} style={{ width: "100%" }}>
            <div style={{ width: "24%" }} className={`middle_sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
              {sidebarList.map((option, index) => (
                <Tooltip key={index} placement="right" label={option.name}>
                  <li
                    onClick={() => {
                      dispatch(setIsShowSettingSidebar(false));
                      localStorage.removeItem("filterData");
                      localStorage.removeItem("selectedSavefilterId");
                    }}
                    className={`option ${isSidebarCollapsed ? "w-fit" : ""} ${option.hasBottomBorder ? "border-bottom" : ""} ${option.specialClass ? "special-class" : ""} ${option.setting_only ? "setting_only" : ""} ${option.blog_only ? "blog_only" : ""}`}
                  >
                    <NavLink to={option.link} className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`} activeclassname="">
                      <img src={option.icon} alt="icon" className="sidebar-icons" />
                    </NavLink>
                  </li>
                </Tooltip>
              ))}
            </div>

            <div className="w-[90%] pl-1" style={{ borderLeft: "1px solid #edf0eb" }}>
              <p className="dark-H head-4 pt-3">Settings</p>

              {settingOptions.map((section, index) => {
                // 🔹 DROPDOWN (Archives, Tags)
                if (section.type === "dropdown") {
                  return (
                    <div key={index}>
                      {/* Dropdown Header */}
                      <li
                        className={`option ${isSidebarCollapsed ? "w-fit" : ""} cursor-pointer`}
                        onClick={() => toggleSetting(section.title)}
                      >
                        <div className="option-link body-N">
                          <div className="flex items-center justify-between w-full">
                            <p className="text-left">{section.title}</p>
                            <span className="ml-2 text-[#6B7280] text-sm leading-none">
                              {openSetting === section.title ? "−" : "+"}
                            </span>
                          </div>
                        </div>
                      </li>

                      {/* Dropdown Items */}
                      {openSetting === section.title &&
                        section.items.map((option, i) => (
                          <li
                            key={i}
                            className={`option ${isSidebarCollapsed ? "w-fit" : ""}`}
                            onClick={() => {
                              localStorage.removeItem("filterData");
                              localStorage.removeItem("selectedSavefilterId");
                            }}
                          >
                            <NavLink
                              to={option.link}
                              className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`}
                            >
                              <p className="text-left">{option.name}</p>
                            </NavLink>
                          </li>
                        ))}
                    </div>
                  );
                }

                // 🔹 NORMAL ITEMS (NO "Others" heading)
                return section.items.map((option, i) => (
                  <li
                    key={`${index}-${i}`}
                    className={`option ${isSidebarCollapsed ? "w-fit" : ""}`}
                    onClick={() => {
                      localStorage.removeItem("filterData");
                      localStorage.removeItem("selectedSavefilterId");
                    }}
                  >
                    <NavLink
                      to={option.link}
                      className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`}
                    >
                      <p className="text-left">{option.name}</p>
                    </NavLink>
                  </li>
                ));
              })}
            </div>


          </ul>
        ) : (
          <ul className={`${isSidebarCollapsed ? "options-collapsed" : "options"}`} style={{ width: "100%" }}>
            <div className={`middle_sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
              {sidebarList.map((option, index) => (
                <Tooltip key={index} placement="right" isDisabled={isSidebarCollapsed === false || !isShowSettingSidebar === false} label={option.name}>
                  <li
                    onClick={() => {
                      dispatch(setIsShowSettingSidebar(false));
                      localStorage.removeItem("filterData");
                      localStorage.removeItem("selectedSavefilterId");
                    }}
                    className={`option ${isSidebarCollapsed ? "w-fit" : ""} ${option.hasBottomBorder ? "border-bottom" : ""} ${option.specialClass ? "special-class" : ""} ${option.setting_only ? "setting_only" : ""} ${option.blog_only ? "blog_only" : ""}`}
                  >
                    <NavLink to={option.link} className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`} activeclassname="">
                      <img src={option.icon} alt="icon" className="sidebar-icons" />
                      {!isSidebarCollapsed && <p className="ml-3 body-N text-left">{option.children ? <>{option.name}</> : option.name}</p>}
                    </NavLink>
                  </li>
                </Tooltip>
              ))}
            </div>
          </ul>
        )}
      </div>
    </>
  );
};

export default SidebarComponent;
